<template>
     <v-footer
      :class="{ footlocker: $route.path == '/' }"
      height="auto"
      color="teal lighten-1"
      v-cloak
    >
      <v-layout
        justify-center
        row
        wrap
      >
      <div :key="link.name" v-for="link in links">
        <v-btn
          :key="link"
          color="white"
          flat
          round
          :href="link.link"
        >
          {{ link.name }}
        </v-btn>
      </div>        
        <v-flex
          teal
          lighten-2
          py-3
          text-xs-center
          white--text
          xs12
        >
          &copy;{{ new Date().getFullYear() }} — <strong>Pawtocol</strong><br>Information presented on this site is confidential and subject to change
        </v-flex>
      </v-layout>
    </v-footer>
</template>

<script>
export default {
  data() {
    return {
      links: [
        { name: 'Home', link: 'https://pawtocol.com' },
        { name: 'How it Works', link: 'https://pawtocol.com/#how_pawtocol' },
        { name: 'The App', link: 'https://pawtocol.com/#theApp' },
        { name: 'About Us', link: 'https://pawtocol.com/#about_bottom_page' },
        { name: 'FAQ', link: 'https://pawtocol.com/#questions_outer' }
      ]
    }
  }
}    
</script>

<style>
  
</style>